import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [],
  templateUrl: './notification.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './notification.scss',
})
export class Notification { }